export enum SideNavLocation {
  Care = 'Care',
  Home = 'Home',
  Support = 'Support',
  Labs = 'Labs',
}
